import * as React from "react";
import { Typography } from "@mui/material";
import "./showDetailAttachment.scss";
import SlideshowPopUp from "../attachedSlideShow/SlideshowPopUp";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import AttachmentList from "./AttchementList";
import { useParams } from "react-router-dom";
import { useDetailAttachmentsState } from "./hooks/useDetailAttachmentsState";

export default React.memo(function AttachmentCard({ cardId }) {
  const { id: boardId } = useParams();
  const {
    attachmentId,
    attachments,
    deleteAttachment,
    handleDelete,
    handleDeleteConfirm,
    handleDownload,
    handleSlideShowAttachment,
    handleView,
    isMobile,
    isPending,
    setDeleteAttachment,
    setShowAttachmentSlideShow,
    showAttachmentSlideShow,
    totalRecord,
  } = useDetailAttachmentsState({
    boardId,
    cardId,
  });

  return (
    <>
      {showAttachmentSlideShow && attachmentId && (
        <SlideshowPopUp
          attachmentId={attachmentId}
          slideImages={attachments}
          showAttachmentSlideShow={showAttachmentSlideShow}
          setShowAttachmentSlideShow={setShowAttachmentSlideShow}
        />
      )}

      {deleteAttachment && (
        <FormDialog
          open={deleteAttachment}
          handleClose={() => setDeleteAttachment(false)}
          handleSubmit={handleDeleteConfirm}
          loading={isPending}
          buttonTxt="Delete"
          title="Confirmation: Delete"
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to you want to delete this item? This action can not be
            undone
          </Typography>
        </FormDialog>
      )}

      <AttachmentList
        attachments={attachments}
        isMobile={isMobile}
        totalRecord={totalRecord}
        cardId={cardId}
        handleSlideShowAttachment={handleSlideShowAttachment}
        handleView={handleView}
        handleDownload={handleDownload}
        handleDelete={handleDelete}
      />
    </>
  );
});
